import React from 'react';
import { StateContext } from '../services/LabSimService';
import { T } from '@testout/labsim-ui-atomics';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => (React.createElement(ModulePublishControl, Object.assign({}, props, { context: stateContext }))))));
export var ModulePublishControlEventType;
(function (ModulePublishControlEventType) {
    ModulePublishControlEventType[ModulePublishControlEventType["CHECKBOX_CHANGE"] = 0] = "CHECKBOX_CHANGE";
    ModulePublishControlEventType[ModulePublishControlEventType["MODULE_CHANGE"] = 1] = "MODULE_CHANGE";
    ModulePublishControlEventType[ModulePublishControlEventType["READY"] = 2] = "READY";
})(ModulePublishControlEventType || (ModulePublishControlEventType = {}));
class ModulePublishControl extends React.Component {
    constructor(props) {
        super(props);
        this.handleCanvasLoad = () => {
            if (this.props.onReady && this.props.context.canvasAssignmentGroups.length > 0) {
                // default to none
                this.setState({ selectedModule: '' }, () => {
                    if (this.props.onReady) {
                        this.props.onReady({
                            module: this.state.selectedModule,
                            publishOnCreation: this.state.publishOnCreation,
                            type: ModulePublishControlEventType.READY,
                        });
                    }
                });
            }
        };
        this.handleCheckboxChange = (checked) => {
            this.setState((state) => ({ publishOnCreation: !state.publishOnCreation }), () => {
                this.props.onChange({
                    module: this.state.selectedModule,
                    publishOnCreation: this.state.publishOnCreation,
                    type: ModulePublishControlEventType.CHECKBOX_CHANGE,
                });
            });
        };
        this.handleModuleChange = (module) => {
            this.setState({ selectedModule: module }, () => {
                this.props.onChange({
                    module: this.state.selectedModule,
                    publishOnCreation: this.state.publishOnCreation,
                    type: ModulePublishControlEventType.MODULE_CHANGE,
                });
            });
        };
        this.state = {
            publishOnCreation: props.publishDefault,
            selectedModule: '',
        };
        this._moduleRef = React.createRef();
        props.context.onCanvasDataLoaded().then(this.handleCanvasLoad);
    }
    componentDidUpdate(prevProps, prevState) {
        var _a;
        // if we have changes the allowNone and previously the module was None (''), then update module and trigger change event
        if (prevProps.allowNoneOption !== this.props.allowNoneOption &&
            prevState.selectedModule === '') {
            this.setState({
                selectedModule: ((_a = this._moduleRef.current) === null || _a === void 0 ? void 0 : _a.options[0].value) || '',
            }, () => {
                this.props.onChange({
                    module: this.state.selectedModule,
                    publishOnCreation: this.state.publishOnCreation,
                    type: ModulePublishControlEventType.MODULE_CHANGE,
                });
            });
        }
    }
    render() {
        return (React.createElement(StateContext.Consumer, null, (stateContext) => {
            if (!stateContext.canvasDataLoaded)
                return null;
            const isLTIAdvantage = stateContext.isIntegrationLTIAdvantage();
            return (React.createElement("div", null,
                stateContext.isFamilyCanvas() && (React.createElement(T.Form.Field, { automationId: 'moduleSelect', required: true },
                    React.createElement(T.Form.Label, null, "Module"),
                    React.createElement(T.Form.Select, { onChange: this.handleModuleChange, value: this.state.selectedModule },
                        stateContext.canvasModules.map((m) => (React.createElement(T.Select.Option, { key: m.id, value: m.id }, m.name))),
                        this.props.allowNoneOption && (React.createElement(T.Select.Option, { value: '' }, "None"))))),
                !isLTIAdvantage && (React.createElement(T.Form.Field.CheckboxGroup, { automationId: 'publish' },
                    React.createElement(T.Form.Checkbox, { name: 'shouldPublish', checked: this.state.publishOnCreation, onChange: this.handleCheckboxChange }, "Publish assignment on creation")))));
        }));
    }
}
//# sourceMappingURL=ModulePublishControl.js.map